import { render, staticRenderFns } from "./MonthlyRetentionPage.vue?vue&type=template&id=5271c99e&scoped=true&"
import script from "./MonthlyRetentionPage.vue?vue&type=script&lang=js&"
export * from "./MonthlyRetentionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271c99e",
  null
  
)

export default component.exports